module.exports = __webpack_public_path__ + "img/mariafranciscamardones.69375369.jpg";